import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-99cc9378")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProviderCoupons = _resolveComponent("ProviderCoupons")

  return (_openBlock(), _createBlock("div", {
    class: ["businessClients-table-container container", { 'businessClients-table-container-mobile': _ctx.isMobile }]
  }, [
    _createVNode(_component_ProviderCoupons, { "business-client-id": _ctx.businessClientId }, null, 8, ["business-client-id"])
  ], 2))
})